"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestorTestRating = exports.InvestorName = exports.ReportType = void 0;
var ReportType;
(function (ReportType) {
    ReportType["TALCOTT"] = "talcott_credit_box_v1";
    ReportType["PEAK_ROCK"] = "peakrock_investor_test";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
var InvestorName;
(function (InvestorName) {
    InvestorName["TALCOTT"] = "Talcott";
    InvestorName["PEAK_ROCK"] = "Peak Rock";
})(InvestorName = exports.InvestorName || (exports.InvestorName = {}));
var InvestorTestRating;
(function (InvestorTestRating) {
    InvestorTestRating["TRUE"] = "TRUE";
    InvestorTestRating["FALSE"] = "FALSE";
})(InvestorTestRating = exports.InvestorTestRating || (exports.InvestorTestRating = {}));
//# sourceMappingURL=CreditBox.js.map